export const QUALIFICATION_OPTIONS = [
  '10th / SSC',
  '12th / HSC',
  'Diploma',
  'Bachelor\'s (Pursuing)',
  'Bachelor\'s (Completed)',
  'Master\'s (Pursuing)',
  'Master\'s (Completed)',
  'PhD',
  'Other',
] as const;

export const COURSE_OPTIONS = [
  'Computer Science & IT',
  'Data Science & AI',
  'Business & MBA',
  'Engineering',
  'Medicine & Healthcare',
  'Law',
  'Arts & Humanities',
  'Design & Architecture',
  'Hospitality & Tourism',
  'Finance & Accounting',
  'Psychology',
  'Environmental Science',
  'Other',
] as const;

export const INTAKE_OPTIONS = [
  'January 2026',
  'May 2026',
  'September 2026',
  'January 2027',
  'May 2027',
  'September 2027',
  'Not sure yet',
] as const;

export const BUDGET_RANGE_OPTIONS = [
  'Under ₹10 Lakhs',
  '₹10 – 20 Lakhs',
  '₹20 – 35 Lakhs',
  '₹35 – 50 Lakhs',
  'Above ₹50 Lakhs',
  'Need scholarship / loan support',
] as const;

export const ENGLISH_TEST_OPTIONS = [
  'Not taken yet',
  'Preparing for IELTS',
  'Preparing for PTE',
  'IELTS score available',
  'PTE score available',
  'Exempt (English-medium education)',
] as const;

export const YES_NO_OPTIONS = ['Yes', 'No'] as const;

export const COUNTRY_OPTIONS = [
  'India',
  'United Kingdom',
  'Canada',
  'United States',
  'Australia',
  'Germany',
  'France',
  'Ireland',
  'New Zealand',
  'Singapore',
  'Netherlands',
  'Other',
] as const;
